import { render, staticRenderFns } from "./CentersView.vue?vue&type=template&id=2069f47b"
import script from "./CentersView.vue?vue&type=script&lang=js"
export * from "./CentersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports